module.exports = __webpack_public_path__ + "img/banner-header_02-profesionales-independientes-y-pymes.cce3c4c6.png";